module.exports = __webpack_public_path__ + "img/austria-digestive-diseases-female.ae662b8f.png";